import { createFileRoute } from '@tanstack/react-router';
import { TransactionsPage } from '../components/pages/TransactionsPage/TransactionsPage';
import { z } from 'zod/mini';

const transactionsSearchSchema = z.object({
  cardId: z.optional(z.string()),
  vaultId: z.optional(z.string()),
  accountId: z.optional(z.string()),
  until: z.optional(z.string()),
  since: z.optional(z.string()),
  categories: z.optional(z.array(z.string())),
  beneficiaryIds: z.optional(z.array(z.string())),
});

export const Route = createFileRoute('/account/transactions')({
  validateSearch: (search) => transactionsSearchSchema.parse(search),
  component: TransactionsPage,
});
